<mat-card appearance="outlined" fxLayout="column" fxLayoutAlign="start stretch">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-card-title fxLayoutAlign="center center" fxLayout="row" fxFlex>
      <h2>Hire Items</h2>
    </mat-card-title>
    <button mat-icon-button color="accent" (click)="copyHireItems()">
      <mat-icon>file_copy</mat-icon>
    </button>
  </div>
  <mat-card-content fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px">
    <ng-container *ngIf="loading$ | async; else itemTable">
      <ngx-skeleton-loader count="3" apppearance="line"></ngx-skeleton-loader>
    </ng-container>

    <ng-template #itemTable>
      <div class="w-full overflow-x-auto">
        <table class="table" id="hire-items">
          <thead>
            <tr>
              <th *ngIf="shouldShowOffHireToggle$ | async">
                <mat-checkbox class="example-margin" name="Item Select" [checked]="allSelected$ | async"
                  (change)="toggleSelectAll($event.checked)" testId="select-all-hire-items"></mat-checkbox>
              </th>
              <th>Qty</th>
              <th>Product</th>
              <th>On Hire</th>
              <th>Est. Off Hire</th>
              <th>Off Hire</th>
              <th>Price</th>
              <th *ngIf="!previewMode"></th>
            </tr>
          </thead>
          <tbody>
            @if (totalHireItemsCount$ | async) {
            @for (hireItem of hireItems$ | async; track hireItem.id) {
            <tr *ngIf="!hireItem.deleted" class="group">
              <td width="5%" *ngIf="shouldShowOffHireToggle$ | async">
                <mat-checkbox name="Item Select" class="select-item-off-hire" *ngIf="hireItem.off_hire === null"
                  [(ngModel)]="selectedMap[hireItem.id]" (change)="onSelectionChanged(hireItem.id, $event.checked)"
                  testId="select-hire-item-{{ hireItem.id }}"></mat-checkbox>
              </td>
              <td>
                {{ hireItem.quantity }}
              </td>
              <td class="product-name">
                <app-product-name-cell [hireItem]="hireItem"></app-product-name-cell>
              </td>

              <td class="on-hire" width="20%">
                {{ hireItem.on_hire | amDateFormat: dateTimeFormat }}
                <p class="text-xs">
                  From
                  {{ hireItem.location_out | locationNameFromId | async }}
                  ({{ hireItem.user_id | userIdToName | async }})
                </p>
              </td>
              <td class="est-off-hire" width="20%">
                <div class="flex flex-row justify-start items-center space-x-4">
                  <p>
                    {{
                    hireItem.estimated_off_hire
                    | amDateFormat: dateTimeFormat
                    }}
                  </p>
                  <app-conflict-count *ngIf="hireItem.off_hire === null" [count]="hireItem.conflictCount"
                    [hireItemId]="hireItem.id"></app-conflict-count>
                </div>
              </td>
              <td class="off-hire" width="20%">
                <ng-container *ngIf="hireItem.off_hire">
                  {{ hireItem.off_hire | amDateFormat: dateTimeFormat }}
                  <p class="text-xs">
                    To
                    {{ hireItem.location_in | locationNameFromId | async }}
                    ({{ hireItem.off_hired_by | userIdToName | async }})
                  </p>
                </ng-container>
              </td>
              <td class="charge" width="10%">
                <div class="flex flex-col">
                  <div class="flex flex-row justify-start items-center">
                    <p *ngIf="hireItem.charge || hireItem.charge === 0">
                      {{
                      hireItem.charge * currencyRate
                      | currency: currency : 'symbol' : '1.2-2'
                      }}
                    </p>
                    @if(!previewMode) {
                    <button class="group-hover:visible group-active:visible invisible" mat-icon-button
                      (click)="openPriceSettings(hireItem)">
                      <mat-icon>settings</mat-icon>
                    </button>
                    }
                  </div>
                  <span data-cy="price-breakdown" *ngIf="
                          hireItem.price_suggestion?.estimate &&
                          hireItem.price_suggestion.estimate.price.toString() ===
                            hireItem.charge?.toString()
                        ">
                    <small>
                      {{
                      hireItem.price_suggestion
                      | priceEstimateBreakdown
                      : currency
                      : currencyRate
                      : hireItem.quantity
                      }}
                    </small>
                  </span>
                </div>
              </td>
              <td class="hire-item-options text-right" width="10%" *ngIf="!previewMode">
                <span *ngIf="(disableActions | async) === false"
                  class="invisible group-hover:visible group-active:visible">
                  <a (click)="attach(hireItem)">Attach</a>
                  <span class="text-gray"> | </span>
                  <a (click)="showEditOnHireDialog(hireItem)" data-cy="edit">Edit</a>
                  <span class="text-gray"> | </span>
                  <a (click)="openDeleteDialog(hireItem)" data-cy="delete">Delete</a>
                </span>
              </td>
            </tr>
            @if (hireItem.notes || hireItem.attachments.length || (trackedAttributes[hireItem.id] | async)) {
            <tr>
              <td colspan="100%" class="with-above-row">
                <div class="flex flex-row justify-start items-center" *ngIf="
                        trackedAttributes[hireItem.id] &&
                        (trackedAttributes[hireItem.id] | async) as value
                      ">
                  <app-tracked-attributes-prompt [attributes]="value.attributes" [event]="value.event"
                    [itemId]="hireItem.item_id" [promptableId]="hireItem.id" [itemCode]="hireItem.item.code"
                    (addedAttributes)="
                          trackedAttributesAdded(hireItem.id, $event)
                        " promptableType="hireItem"></app-tracked-attributes-prompt>
                </div>
                <div class="flex flex-col justify-start items-start space-y w-full">
                  <p class="flex w-full whitespace-pre-wrap" *ngIf="hireItem.notes"
                    testId="hire-item-notes-{{ hireItem.id }}">
                    <strong>Notes:</strong> {{ hireItem.notes }}
                  </p>
                  @if (hireItem.attachments.length > 0) {
                  <div class="w-full">
                    <app-hire-item-attachment-list [attachments]="hireItem.attachments">
                    </app-hire-item-attachment-list>
                  </div>
                  }
                </div>
              </td>
            </tr>
            }
            @if (hireItem.children.length > 0) {
            @for (child of hireItem.children; track child.id) {
            <tr>
              <td></td>
              <td colspan="100%">
                <app-product-name-cell [hireItem]="child" [showQuantity]="true"></app-product-name-cell>
                @if (child.notes) {
                <p class="flex w-full whitespace-pre-wrap" testId="hire-item-notes-{{ child.id }}">
                  <strong>Notes:</strong> {{ child.notes }}
                </p>
                }
              </td>
            </tr>

            @if (trackedAttributes[child.id] && (trackedAttributes[child.id] | async); as attributes) {
            <tr>
              <td></td>
              <td colspan="100%">
                <app-tracked-attributes-prompt [attributes]="attributes.attributes" [event]="attributes.event"
                  [itemId]="child.hireable_id" [promptableId]="child.id" [itemCode]="$any(child.hireable).code"
                  (addedAttributes)="trackedAttributesAdded(child.id, $event)"
                  promptableType="hireItem"></app-tracked-attributes-prompt>
              </td>
            </tr>
            }
            }
            }
            }
            } @else {
            <tr>
              <td colspan="100%">
                <p class="tracking-wide italic text-center text-gray-700">
                  No items added
                </p>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </ng-template>
    <div *ngIf="!previewMode"
      class="flex flex-col justify-start items-start space-y-4 md:space-y-0 space-x-0 md:space-x-4">
      <ng-container *ngIf="!docketClosed; else docketClosedMessage">
        <button mat-flat-button color="primary" [disabled]="(selectedCount$ | async) === 0" (click)="offHireItems()"
          data-cy="off-hire" class="md:basis-1/3 lg:basis-1/5 flex-shrink-0 !h-auto">
          <p>Off Hire Selected</p>
        </button>
        <div
          class="bg-green-50 self-center w-full lg:w-1/2 border-green-900 border rounded p-2 md:py-6 my-12 md:px-8 flex flex-row justify-stretch items-center">
          <item-search searchType="docket" (optionSelected)="optionSelected($event)" class="w-full"></item-search>
        </div>
        <div></div>
      </ng-container>
      <ng-template #docketClosedMessage>
        <div fxFlex fxLayout="row" fxLayoutAlign="center center">
          <p id="docket-closed">
            This hire contract is closed, you cannot add any more items to it.
          </p>
        </div>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>